import { LoaderIcon } from '../../svg'
import { ColorType, cn } from '../../utils'
import { Icon } from '../Icon'
import { Text } from '../Text'
import {
    getBaseClasses,
    getLoaderSizes,
    getVariantClasses,
} from './Loader.styles'
import { LoaderVariant } from './Loader.types'

type LoaderSize = 'sm' | 'base' | 'md' | 'lg'

export const Loader = ({
    text,
    color = 'gradient',
    className,
    variant = 'contained',
    viewBox = '0 0 20 20',
    size = 'md',
    strokeColor = 'fill-background-base',
    textClassName,
}: {
    text: string
    color?: ColorType
    className?: string
    variant: LoaderVariant
    viewBox?: string
    size: LoaderSize
    strokeColor?: string
    textClassName?: string
}) => {
    const classes = cn(
        getBaseClasses(),
        getLoaderSizes(size),
        getVariantClasses(variant, color),
        'fill-background-base'
    )
    return (
        <div className="flex w-full items-center justify-center gap-2">
            <Icon
                variant={variant}
                color={color}
                viewBox={viewBox}
                stroke={strokeColor}
                className={cn(classes, className)}
                size={size}
            >
                <LoaderIcon />
            </Icon>
            <Text
                className={cn('hidden sm:inline', textClassName)}
                text={text}
                color={color}
                variant={variant}
                size={size}
            />
        </div>
    )
}
